<template>
  <div>
    <div class="login-block">
      <div class="bg-image"></div>
      <LoadingSpinner v-if="cargando" />
      <div class="container-login">
        <div class="login-shell">
          <div class="login-sec">
            <div class="login-sec-inner">
              <div class="login-logo-wrap">
                <img
                  src="/img/logos/logo-sos.png"
                  alt="S.O.S Contingencias"
                  class="login-sec-logo"
                />
              </div>
              <form
                class="login-sec-form"
                @submit.prevent="login"
                autocomplete="on"
              >
                <div
                  class="login-field"
                  :class="{
                    'is-invalid':
                      $v.form.email.$dirty && $v.form.email.$invalid,
                    'is-valid': $v.form.email.$dirty && !$v.form.email.$invalid,
                  }"
                >
                  <span
                    class="login-field__icon"
                    aria-hidden="true"
                  >
                    <i class="fas fa-user"></i>
                  </span>
                  <input
                    type="email"
                    class="login-field__input"
                    v-model.trim="form.email"
                    placeholder="Correo electrónico"
                    autocomplete="username"
                    name="email"
                  />
                </div>

                <div
                  class="login-field"
                  :class="{
                    'is-invalid':
                      $v.form.password.$dirty && $v.form.password.$invalid,
                    'is-valid':
                      $v.form.password.$dirty && !$v.form.password.$invalid,
                  }"
                >
                  <span
                    class="login-field__icon"
                    aria-hidden="true"
                  >
                    <i class="fas fa-lock"></i>
                  </span>
                  <input
                    ref="inputPassword"
                    :type="showPassword ? 'text' : 'password'"
                    class="login-field__input"
                    v-model="form.password"
                    placeholder="Contraseña"
                    autocomplete="current-password"
                    name="password"
                    @animationstart="onPasswordAutofill"
                  />
                  <button
                    v-show="form.password"
                    type="button"
                    class="login-field__toggle"
                    @click="togglePasswordVisibility"
                    :aria-label="
                      showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'
                    "
                  >
                    <i
                      :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                    ></i>
                  </button>
                </div>

                <div class="login-meta">
                  <label class="login-remember">
                    <input
                      v-model="form.remember"
                      type="checkbox"
                      name="remember"
                    />
                    <span>Recordarme</span>
                  </label>
                  <router-link
                    class="login-forgot"
                    to="/ForgotPassword"
                  >
                    ¿Olvidaste tu clave?
                  </router-link>
                </div>

                <button
                  type="submit"
                  class="btn-login"
                  :class="{ 'btn-login--ready': !$v.form.$invalid }"
                  :disabled="$v.form.$invalid || cargando"
                >
                  <span
                    v-if="cargando"
                    class="spinner-border spinner-border-sm mr-1"
                    role="status"
                  ></span>
                  <span v-else>Ingresar</span>
                </button>
              </form>

              <div class="login-brand-footer">
                <img
                  src="/img/logos/Logo-Support-7-24.png"
                  alt="Support 7-24"
                  class="login-brand-footer__img"
                />
              </div>
            </div>
          </div>

          <div class="banner-sec">
            <img
              class="banner-sec__img"
              src="/img/fondos/banerinicio3.png"
              alt="Support 7-24"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import LoadingSpinner from "../components/LoadingSpinner";

export default {
  components: {
    LoadingSpinner,
  },
  name: "LoginForm",
  data: () => ({
    user: {},
    form: {
      email: "",
      password: "",
      remember: false,
    },
    showPassword: false,
    cargando: false,
  }),

  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },

  created() {
    this.verifyPersistedSession();
  },
  methods: {
    async verifyPersistedSession() {
      if (!this.$store.getters.isAuthenticated) {
        return;
      }
      await this.$store.dispatch("getUser");
      if (this.$store.getters.isAuthenticated) {
        if (this.$store.getters.requiresTwoFactorSetup) {
          return this.$router.replace({ name: "PerfilUsuario" });
        }
        return this.$router.replace("/");
      }
    },
    syncPasswordFromDom() {
      const el = this.$refs.inputPassword;
      if (!el || typeof el.value !== "string") return;
      if (el.value && el.value !== this.form.password) {
        this.form.password = el.value;
      }
    },
    onPasswordAutofill(e) {
      const name = (e && e.animationName) || "";
      if (name.indexOf("onAutoFill") !== -1) {
        this.syncPasswordFromDom();
      }
    },
    mostrarError(text) {
      this.$swal({ icon: "error", title: "Oops...", text });
    },
    async login() {
      if (this.cargando) return;
      this.syncPasswordFromDom();
      if (this.$v.form.$invalid) {
        this.$v.form.$touch();
        return;
      }
      this.cargando = true;
      try {
        const result = await this.$store.dispatch("login", this.form);
        if (result === "two_factor") {
          return this.$router.push({ name: "TwoFactorChallenge" });
        }
      } finally {
        this.cargando = false;
      }

      if (this.$store.getters.isAuthenticated) {
        if (this.$store.getters.requiresTwoFactorSetup) {
          return this.$router.replace({ name: "PerfilUsuario" });
        }
        return this.$router.replace("/");
      }

      const err = this.$store.getters.getErrors;
      const msg =
        this.$store.getters.getMensajeLogin ||
        "No fue posible completar el inicio de sesión. Inténtalo de nuevo.";

      if (err === "password_expired" || err === "password_updated_at") {
        await this.$swal({
          icon: "error",
          title: "Oops...",
          text: msg,
        });
        this.$store.commit("SET_ERRORS", null);
        this.$store.commit("SET_MENSAJE_LOGIN", null);
        return this.$router.push({
          name: "ResetPassword",
          params: { token: "token", email: this.form.email },
        });
      }

      return this.mostrarError(msg);
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
  mounted() {
    this.$store.commit("SET_PENDING_TWO_FACTOR", false);
    this.$nextTick(() => {
      setTimeout(() => this.syncPasswordFromDom(), 100);
      setTimeout(() => this.syncPasswordFromDom(), 400);
      setTimeout(() => this.syncPasswordFromDom(), 800);
    });
  },
};
</script>

<style>
.login-block {
  width: 100%;
  min-height: 100vh;
  padding: 28px 16px;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  /* Mismo fondo de siempre: degradado + patrón SOS (sin animación que lo “cambie”) */
  background: linear-gradient(to bottom right, #153f75, #bad35c);
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("../../public/img/fondos/fondo_sos_contingencias.png");
  background-size: cover;
  background-position: center;
  opacity: 0.35;
  pointer-events: none;
}

.container-login {
  position: relative;
  z-index: 1;
  width: min(980px, 94vw);
  max-width: 980px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.22);
  overflow: hidden;
}

.login-shell {
  display: grid;
  grid-template-columns: 38% 62%;
  height: 480px;
  min-height: 480px;
  align-items: stretch;
}

.login-sec {
  display: flex;
  align-items: stretch;
  justify-content: center;
  background: #fff;
  padding: 1.15rem 1.4rem 1rem;
  box-sizing: border-box;
  height: 100%;
}

.login-sec-inner {
  width: 100%;
  max-width: 260px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  min-height: 100%;
  height: 100%;
}

.login-logo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 0 0 auto;
  margin: 0 0 0.35rem;
}

.login-sec-logo {
  display: block;
  width: 148px;
  max-width: 100%;
  height: auto;
}

.login-sec-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: 0;
}

.login-field {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 0.55rem;
  background: #f2f2f2;
  border-radius: 999px;
  border: 1px solid transparent;
  min-height: 40px;
  padding: 0 0.9rem;
  transition: border-color 0.15s ease;
}

.login-field.is-invalid {
  border-color: #dc3545;
}

.login-field.is-valid {
  border-color: #28a745;
}

.login-field__icon {
  color: #9aa0a8;
  font-size: 0.82rem;
  width: 1.1rem;
  text-align: center;
  flex: 0 0 auto;
}

.login-field__input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  height: 40px;
  padding: 0 0.55rem;
  margin: 0;
  font-size: 0.86rem;
  color: #2b2f36;
  width: 100%;
  text-align: left;
}

.login-field__input::placeholder {
  color: #9aa0a8;
}

.login-field__input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #f2f2f2 inset !important;
  border-radius: 999px;
  animation-name: onAutoFillStart;
  animation-duration: 0.001s;
}

.login-field__toggle {
  border: 0;
  background: transparent;
  color: #9aa0a8;
  padding: 0.25rem;
  cursor: pointer;
  line-height: 1;
  flex: 0 0 auto;
}

.login-field__toggle:hover {
  color: #333;
}

.login-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  gap: 0.5rem;
  margin: 0.15rem 0 0.9rem;
  text-align: left;
}

.login-remember {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0;
  font-size: 0.74rem;
  color: #6c757d;
  cursor: pointer;
  white-space: nowrap;
}

.login-remember input {
  margin: 0;
  position: static;
}

.login-forgot {
  font-size: 0.74rem;
  font-weight: 600;
  color: #b11226;
  text-decoration: none;
  white-space: nowrap;
}

.login-forgot:hover {
  color: #8b1e2d;
  text-decoration: underline;
}

.btn-login {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  min-height: 40px;
  margin: 0;
  border: 0;
  border-radius: 10px;
  background: #9fa3a9;
  color: #fff;
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  transition: background 0.15s ease;
}

.btn-login:disabled {
  opacity: 1;
  cursor: not-allowed;
}

.btn-login--ready {
  background: #153f75;
}

.btn-login--ready:hover:not(:disabled) {
  background: #0f2f58;
}

.login-brand-footer {
  margin-top: auto;
  padding-top: 0.85rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
}

.login-brand-footer__img {
  display: block;
  width: 148px;
  max-width: 100%;
  height: auto;
}

.banner-sec {
  position: relative;
  height: 100%;
  overflow: hidden;
  background: #111;
}

.banner-sec__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@keyframes onAutoFillStart {
  from {
    opacity: 0.99;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 767.98px) {
  .login-block {
    padding: 16px 12px;
    position: relative;
    height: auto;
  }

  .container-login {
    width: 100%;
    max-width: 420px;
    box-shadow: 10px 10px 0 rgba(0, 0, 0, 0.1);
  }

  .login-shell {
    grid-template-columns: 1fr;
    height: auto;
    min-height: 0;
  }

  .login-sec {
    padding: 1rem 1.25rem 1.15rem;
    height: auto;
  }

  .login-sec-inner {
    max-width: 280px;
  }

  .banner-sec {
    height: 200px;
  }

  .banner-sec__img {
    height: 200px;
  }
}
</style>
